module.exports = __webpack_public_path__ + "img/img_app_2.8df73521.jpg";